import React from 'react';
import { ClipLoader } from 'react-spinners';

const override = {
    display: 'block'
};

const LoaderOverlay = () => (
    <div className="flex justify-center items-center min-h-[calc(100vh-12rem)]">
        <ClipLoader
            color="#1D4ED8"
            loading={true}
            cssOverride={override}
            size={50}
            speedMultiplier={0.7}
        />
    </div>
);

export default LoaderOverlay;